
export const storageProductsChars = 'galaxy-products-chars' // в сессии хранит выбранные характеристики в листинге товаров
export const storageProductOffsetTop = 'galaxy-products-offset-top' // когда возвращаешься в листинг товаров - высота на которую нужно прокрутить для показа тех же товаров
export const storageFilters = 'galaxy-catalog-filters' // хранит выбранные фильтры